import AuthLayout from './AuthLayout.vue'
import MainLayout from './MainLayout.vue'
export default {
    AuthLayout, MainLayout
}